import type { TowerShipment } from "../../../types/controlTower";
import { ROUTE_DAY_START_HOUR } from "./towerShared";

export type RouteStop = { order: number; shipment: TowerShipment; time: string; gapMinutes: number | null };
export type DriverRoute = { stops: RouteStop[]; withoutTime: number };

// Visitas del recorrido: entregas, ausencias, no entregados y rechazos en la
// puerta. Lo que sigue en camino o pendiente todavía no se visitó, y las
// reprogramaciones de Meli (automáticas, de noche) o del comprador no son una
// parada del chofer.
function isRouteVisit(shipment: TowerShipment): boolean {
  return shipment.status === "delivered" || shipment.status === "incident" || /RECHAZAD/i.test(shipment.rawStatus);
}

const STATE_TIME = /^(\d{4}-\d{2}-\d{2}) (\d{2}):(\d{2})$/;

// Recorrido real del día: las visitas en el orden en que el chofer las
// registró en Lightdata (fecha de estado, hora argentina). No es GPS: si marca
// varias juntas, quedan con la misma hora y se ordenan por tracking. Las
// visitas del día sin hora no se pueden ubicar en el orden y se cuentan aparte.
// Las de madrugada (antes de las 6:00) son del recorrido de la noche anterior.
export function buildDriverRoute(shipments: TowerShipment[], date: string): DriverRoute {
  let withoutTime = 0;
  const timed: { shipment: TowerShipment; time: string; minutes: number }[] = [];
  for (const shipment of shipments) {
    if (!isRouteVisit(shipment) || !shipment.stateDate?.startsWith(date)) continue;
    const match = STATE_TIME.exec(shipment.stateDate);
    if (!match) {
      withoutTime++;
      continue;
    }
    if (Number(match[2]) < ROUTE_DAY_START_HOUR) continue;
    timed.push({ shipment, time: `${match[2]}:${match[3]}`, minutes: Number(match[2]) * 60 + Number(match[3]) });
  }
  timed.sort((a, b) => a.minutes - b.minutes || a.shipment.tracking.localeCompare(b.shipment.tracking));
  const stops = timed.map((visit, index) => ({
    order: index + 1,
    shipment: visit.shipment,
    time: visit.time,
    gapMinutes: index === 0 ? null : visit.minutes - timed[index - 1].minutes,
  }));
  return { stops, withoutTime };
}
